var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "25",
      "viewBox": "0 0 24 25",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M10 18.9231H14V16.9231H10V18.9231ZM3 6.9231V8.9231H21V6.9231H3ZM6 13.9231H18V11.9231H6V13.9231Z",
      "fill": "#00A1EC"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }